import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import AppContext from '../../contexts/AppContext';

import { Link, useParams } from 'react-router-dom';
import Spinner from '../../components/spinner/spinner';
import InfoNovaVersao from '../../components/info-nova-versao/info-nova-versao';
import { useNavigate } from 'react-router-dom';
import { Painel } from '../../models/Painel';
import { Modulos } from '../../helpers/constantes/modulo';
import Voltar from '../../components/voltar/voltar';
import './lista-de-paineis.css';
import NotificacaoDeAcessoNegadoAoModulo from '../shared/notificacao-acesso-negado-modulo';
import SessaoUsuarioContext from '../../contexts/SessaoUsuarioContext';
import { AlertaDeErroDeProcessamento } from '../../components/alerta-erro-processamento';
import AmbienteService from '../../services/AmbienteService';
import { useCriarFileParaProcessamento } from '../../hooks/cria-file';

const paineisPessoal = [
  "Dados Demográficos",
  "Perfil Profissional",
  "Absenteísmo",
  "Rotatividade",
  "Custos da Empresa",
  "Gastos da Empresa",
  "SST"
];
const paineisRh = [
  "Desenvolvimento de Talentos",
  "Recrutamento e Seleção"
];
const versaoInicial = "0.0.0";
const modulosDicionario = {
  pessoal: "/atualizar/",
  rh: "/informativo/",
};

const ListaDePaineis = () => {
  const navigate = useNavigate();
  const { modulo } = useParams();
  const { sessao } = useContext(SessaoUsuarioContext);
  const { ambiente: { ambienteDeDadosCriado, paineis } } = useContext(AppContext);
  const [background, setBackground] = useState("");
  const { createFile } = useCriarFileParaProcessamento();

  const paineisParaExibir = useMemo(() => {

    const paineisModulo = modulo === Modulos.Pessoal
      ? paineisPessoal : (modulo === Modulos.Rh) ? paineisRh
        : [];
    const hasCustosDaEmpresa = paineis?.find(painel => painel.nome?.toLowerCase() === "custos da empresa");
    const paineisOrdenados = paineisModulo
      .map((x) => paineis?.find(f => f.nome?.toLowerCase() === x.toLowerCase()))
      .filter(painel => painel !== undefined && painel.nome?.toLowerCase() !== (hasCustosDaEmpresa?.id !== undefined ? "gastos da empresa" : "")) as [];

    return paineisOrdenados as Painel[];
  }, [paineis, modulo]);

  const exibeNotificacao = useMemo(() => {
    return sessao && !sessao.modulosLiberados.some(liberado => modulo?.toLowerCase() === liberado.nome.toLowerCase());
  }, [modulo, sessao])

  useEffect(() => {
    const homeElement = document.querySelector('.lista-de-paineis_background') as HTMLElement
    if (homeElement) {
      setBackground(`/modulo-${modulo}.png`);
    }
  }, [modulo]);

  const atualizarAmbienteHandler = useCallback(async (file: File) => {
    if (sessao) {
      try {
        await AmbienteService.atualizarAmbiente(file);
        atualizaPagina();
      } catch (error) {
        console.log(error);
      }
    }
  }, [sessao]);

  const validaSeLicenciadoNovo = useCallback(async () => {

    let nomeDoArquivo = modulo === "pessoal" ? "pessoal.zip" : "rh.zip"
    const versoesLicenciado = Object.entries(sessao!).filter(([key]) => key.includes("versao" + modulo?.charAt(0).toUpperCase() + modulo!.slice(1)))
      .map(([key, value]) => ({ key, value }));

    if (versoesLicenciado[0].value === versaoInicial || !versoesLicenciado[0].value) {
      const key = modulo as keyof typeof modulosDicionario;
      navigate(modulosDicionario[key] + modulo);
      return
    }

    const fileToUpload = await createFile({
      cnpj: sessao?.licenciadoCnpj!,
      modulo: modulo!,
      nomeDoArquivo: nomeDoArquivo,
      versao: versoesLicenciado[0].value
    });

    await atualizarAmbienteHandler(fileToUpload);
  }, [navigate, modulo, atualizarAmbienteHandler, sessao, createFile])

  useEffect(() => {
    if (ambienteDeDadosCriado === false)
      validaSeLicenciadoNovo();

  }, [ambienteDeDadosCriado, validaSeLicenciadoNovo]);

  return (
    <>
      <h1 className="top-title"><Voltar />Lista de Paineis</h1>
      {ambienteDeDadosCriado && <InfoNovaVersao modulo={modulo} />}
      {exibeNotificacao ? <NotificacaoDeAcessoNegadoAoModulo /> : <></>}
      <AlertaDeErroDeProcessamento modulo={modulo} consideraErroDeAmbiente={false} />
      <div className='painel'>
        <div className='painel__lista__row'>
          <div className='painel__lista__column'>
            <div className='paineis'>
              {!paineis?.length && <>
                <div className='painel__loading'>
                  <Spinner size={170} />
                </div>
              </>}
              {paineisParaExibir?.map(painel => (
                <Link to={painel.status ? `/painel/${modulo}/${painel.nome}` : "#"} 
                  key={painel.id}
                  onClick={(e) => !painel.status && e.preventDefault()}
                  className={`painel__wrapper ${!painel.status ? 'ms-disabled' : ''}`}
                  style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="painel__link-painel">
                  <div>
                    <img src={`/${painel.nome}.png`} alt='' />
                    <label>{painel.nome}</label>
                  </div>
                </div>
              </Link>
              ))}
            </div>

          </div>
          <div className='painel__lista__column'>
            <img className='lista-de-paineis_background' alt='' src={background} />
          </div>
        </div>

      </div>
    </>
  );
};

export default ListaDePaineis;
const atualizaPagina = () => window.location.reload();